module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('vheader'), _c('mobile-nav'), _vm._m(0), _c('footer-user'), _c('vfooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("关于我们")])])]), _c('div', {
    staticClass: "container min"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('p', [_vm._v("「前沿社」是由极客公园发起创立的企业家社群，通过「近场研究FIELD STUDY」、「前沿工作坊FRONTIER WORKSHOP」、「超频之旅OVERCLOCKING TRIP」三大板块，帮助企业家把握技术潮流、连接产业前沿及保持创新思维，以最有效率的方式，让最优秀的企业家与全球顶尖科学家、科技研究者一起迭代进步。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c61af822!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 209
// module chunks = 1